<template>
  <div class="upload-file">
    <b-modal
      id="repInfoRequestForm"
      centered
      size="md"
      hide-footer
      no-close-on-backdrop
      @shown="getOptions"
    >
      <template #modal-header>
        <div class="repInfoRequestForm-header  text-center">
          <h4 v-if="!isEnrollPrime">{{ !row ? "Add" : "" }} Information Request</h4>

          <b-button
            variant="close-btn"
            class="btn-container"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="repInfoRequestForm-form">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form
              @submit.stop.prevent="handleSubmit(createRequest)"
              ref="repInfoRequestContainer"
            >
              <input-multi-select
                :vmodel.sync="form.type"
                labelName="Type"
                :options="filteredTypes.map((type) => type.value)"
                :custom-label="
                  (opt) => filteredTypes.find((x) => x.value == opt).name
                "
                :rules="{ required: true }"
                formGroupClass="form-group mb-3"
                placeholder="Select Type"
                :is-disable="row ? true : false"
              />

              <input-multi-select
                :vmodel.sync="form.policy_id"
                labelName="Member - Policy"
                :options="members.map((type) => type.policy_id)"
                :custom-label="
                  (opt) =>
                    members.find((x) => x.policy_id == opt).formatted_name
                "
                :rules="{ required: true }"
                formGroupClass="form-group mb-3"
                placeholder="Select Member - Policy"
                @onSearchChange="getMembers"
                @input="fetchAddressForPolicy"
                :is-loading="isLoading"
                :is-disable="row ? true : false"
              />

              <!-- Address Field -->
              <input-multi-select
                :vmodel.sync="form.full_address"
                labelName="Full Address"
                :options="address.map((type) => type.formatted_name)"
                :custom-label="
                  (opt) =>
                    address.find((x) => x.formatted_name == opt).formatted_name
                "
                :rules="{ required: true }"
                formGroupClass="form-group mb-3"
                placeholder="Select Full Address"
                :is-loading="isLoading"
                :is-disable="row ? true : false"
              />

              <!-- <input-text
                labelFor="full_address"
                labelName="Full Address"
                inputName="full_address"
                :vmodel.sync="form.full_address"
                formGroupClass="form-group mb-3"
                :readonly="true"
                placeholder="Address will appear here after selecting a policy"
                :is-loading="addressLoading"
              /> -->

              <input-multi-select
                v-if="isEnrollPrime"
                :vmodel.sync="form.cards_requested"
                labelName="Number of Cards Requested"
                :options="requestOptions.map((type) => type.number)"
                :custom-label="
                  (opt) => requestOptions.find((x) => x.value == opt).number
                "
                :rules="{ required: true }"
                formGroupClass="form-group mb-3"
                placeholder="Select Number of Card"
              />

              <input-file v-if="!isEnrollPrime"
                :rules="{ required: false }"
                labelFor="document"
                labelName="Select Document "
                inputName="document"
                :vmodel.sync="form.document"
                :apiErrors="apiErrors"
                formGroupClass="form-group mb-3"
                fieldName="document"
              />

              <input-textarea
                  :rules="{ required: !isEnrollPrime }"
                  labelFor="information"
                  labelName="Information"
                  inputName="information"
                  :vmodel.sync="form.information"
                  formGroupClass="form-group mb-3"
                  :readonly="row? true : false"
              />

              <div class="col-md-12" v-if="!row">
                <b-button
                  class="univ-btnEdit"
                  type="submit"
                  :disabled="isCreate"
                >
                  <template>
                    {{ isCreate ? "Sending Request ..." : "Send Request" }}
                  </template>
                </b-button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import isEnrollPrimeUtil from "@/utils/isEnrollPrimeUtil";
const formData = {
  type: "",
  information: "",
  policy_id: "",
  document: "",
  cards_requested: "",
  full_address: ""
};
export default {
  name: "repInfoRequestForm",
  props: {
    row: {
      default: null,
    },
  },
  watch: {
  'form.policy_id'(newVal) {
    if (newVal) {
      this.fetchAddressForPolicy(newVal);
    }
  }
},
  data() {
    return {
      form: { ...formData },
      isCreate: false,
      isLoading: false,
      addressLoading: false,
      types: [],
      members: [],
      address:[],
      apiErrors: null,
      requestOptions: [
        {
          number: "1",
          value: 1,
        },
        {
          number: "2",
          value: 2,
        },
        {
          number: "3",
          value: 3,
        },
        {
          number: "4",
          value: 4,
        },
        {
          number: "5",
          value: 5,
        },
      ],
    };
  },
  methods: {
    getMembers(query) {
      let url = "v2/rep-info-request/get-members";
      if (query && query.length > 2) {
        this.isLoading = true;
        url = "v2/rep-info-request/get-members?query=" + query;
      }
      Api.get(url)
        .then((response) => {
          this.members = response.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * calling in options api to load in multi selcect form
     */
    fetchAddressForPolicy(policyId) {
      if (!policyId) {
        this.address = [];
        return;
      }

      this.addressLoading = true;

      const tempForm = new FormData();
      tempForm.append("policy_id", policyId);

      Api.post("v2/rep-info-request/get-address", tempForm)
        .then((response) => {
          const addressList = response.data?.data?.address_list || [];

          if (addressList.length > 0) {
            this.address = addressList.map((item) => ({
              policy_id: policyId,
              formatted_name: item.full_address,
            }));

            // Optional: auto-select if only one address exists
            if (addressList.length === 1) {
              this.form.full_address = addressList[0].full_address;
            } else {
              // Clear selection to allow manual selection
              this.form.full_address = "";
            }
          } else {
            this.address = [{
              policy_id: policyId,
              formatted_name: "No address found for this policy",
            }];
            this.form.full_address = "";
          }
        })
        .catch((error) => {
          console.error("Error fetching address:", error);
          this.address = [{
            policy_id: policyId,
            formatted_name: "Unable to fetch address for this policy",
          }];
          this.form.full_address = "";
        })
        .finally(() => {
          this.addressLoading = false;
        });
    },


    getOptions() {
      let loader = this.$loading.show();
      Api.get("v2/rep-info-request/get-options")
        .then((response) => {
          this.types = response.data.data.types;
          this.$nextTick(() => {
            if (this.row) {
              const { type, policy_id, information, full_address } = { ...this.row };
              this.form = {
                type,
                information,
                policy_id: policy_id.toString(),
                full_address: full_address || "",
              };
              this.$nextTick(() => {
                this.getMembers(policy_id.toString());
                if (policy_id && full_address) {
                  this.fetchAddressForPolicy(policy_id);
                }
              });
            } else {
              this.form = { ...formData };
              this.getMembers();
            }
          });
        })
        .finally(() => {
          loader.hide();
        });
    },
    reset() {
      this.form = { ...formData };
    },
    closeModal() {
      this.$emit("update:row", null);
      this.$bvModal.hide("repInfoRequestForm");
      this.reset();
    },
    errorResponse(error) {
      if (error.response.status == 422) {
        this.apiErrors = { ...error.response.data.errors };
        setTimeout(() => {
          this.apiErrors = null;
        }, 5000);
      } else {
        this.$notify(error.response.data.message, "error");
      }
    },
    async createRequest() {
      let url;
      this.isCreate = true;
      url = this.isEnrollPrime
        ? "v2/rep-info-request/enrollprime/store"
        : "v2/rep-info-request/store";
      let loader = this.$loading.show({
        container: this.$refs.createRequestContainer,
      });
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }
      if (!this.isEnrollPrime) {
        formData.delete("cards_requested");
      }
      await Api.post(url, formData)
        .then((res) => {
          this.$notify(res.data.message);
          this.closeModal();
          this.$emit("onSuccess");
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.apiErrors = error.response.data.errors;
            // setTimeout(() => {
            //   this.apiErrors = null;
            // }, 5000);
          } else {
            this.$notify(error.response.data.message, "error");
          }
        })
        .finally(() => {
          this.isCreate = false;
          setTimeout(() => {
            loader.hide();
          }, 2000);
        });
    },
  },
  computed: {
    filteredTypes() {
      return this.isEnrollPrime
        ? this.types.filter((type) => type.value === "member_card")
        : this.types;
    },
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
    selectedMember() {
    return this.members.find((x) => x.policy_id === this.form.policy_id);
  }
  },
};
</script>

<style>
.repInfoRequestForm-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
}
.repInfoRequestForm-header p {
  font-size: 14px;
  color: #2c3f58;
}
.repInfoRequestForm-header button {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.repInfoRequestForm-form label {
  display: block;
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.repInfoRequestForm-header .btn-container {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.repInfoRequestForm-form .multiselect{
    width: 100% !important;
    margin-left: 0 !important;
}
</style>
